// extracted by mini-css-extract-plugin
export default {"underlineNone":"link_underlineNone__+u7f6","link":"link_link__6W8dm"};